import { render, staticRenderFns } from "./ModalSearchBox.vue?vue&type=template&id=0297a369&scoped=true&"
import script from "./ModalSearchBox.vue?vue&type=script&lang=js&"
export * from "./ModalSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0297a369",
  null
  
)

export default component.exports